import { BeforeMergeDataPerVariantSize, BeforeMergeDTO } from '@/typings/preMerge/beforeMerge';
import api from './baseApi';
import type { SignedUrlResponse } from './typings/image';
import { ProductVersions, Product } from '@/api/typings/product';

export const getProductsCount = async (): Promise<number> => {
    const response = await api.get('Product/GetProductsCount');
    return response.data;
};

export const saveProduct = async (product: any): Promise<any> => {
    // New payload shape (avoids jsonString escaping):
    // { product: { ... } }
    const response = await api.post('Product/SaveProduct', { product });
    return response.data;
};

export const getProductImportSignedUrl = (): Promise<SignedUrlResponse> =>
    api.get<SignedUrlResponse>('Product/ImportSignedUrl').then(({ data }) => data);

export const getBeforeMergeData = async (BeforeMergeDTO: BeforeMergeDTO): Promise<BeforeMergeDataPerVariantSize> => {
    const response = await api.post(`/Product/BeforeMerge`, BeforeMergeDTO);
    return response.data;
};

export const getBeforeMergeDataWithoutVariants = async (
    templateProductId: number
): Promise<BeforeMergeDataPerVariantSize> => {
    const response = await api.get(`/Product/BeforeMerge/${templateProductId}`);
    return response.data;
};

export const getProductVersions = async (productId: string): Promise<ProductVersions[]> => {
    const response = await api.get(`/Product/ProductVersions?productId=${productId}`);
    return response.data;
};

export const getProduct = async (productId: string): Promise<Product[]> => {
    const response = await api.get('/Product', {
        params: {
            productId,
            useListEPS: true
        }
    });
    return response.data;
};

export const createProductFromVersion = async (
    productId: string,
    versionId: string,
    productName: string
): Promise<string> => {
    const response = await api.post('/Product/CreateProductFromVersion', {
        templateId: productId,
        versionId: versionId,
        templateName: productName
    });
    return response.data;
};
